module.exports = __webpack_public_path__ + "static/media/result_nare_cup.b2bdee21.jpg";